import React from 'react';
import withErrorCatcher from '../../../components/Common/withErrorCatcher.js'
import { push } from 'react-router-redux';
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withStyles } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import AppContent from '@components/App/appContent';
import Paper from '@material-ui/core/Paper';
import PageContentWrapper from '@components/App/PageComponents/pageContentWrapper';
import Typography from '@material-ui/core/Typography';
import AdminSettingsDrawer from '../../../components/App/Drawers/adminSettingsDrawer';
import AdminSettingsTitle from '../Common/AdminSettingsTitle.js';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
    progress: {
        margin: `0 ${theme.spacing.unit * 2}px`,
        textAlign: 'center',
        align: 'center'
    },
    spinner: {
        textAlign: 'center',
        paddingTop: 16
    },
    paper: {
        padding: 16
    },
    paperStyle: {
        marginBottom: 40
    },
    listStyle: {
        paddingTop: 0,
        paddingBottom: 0
    },
    button: {
        margin: 16
    }
})

export class Classification extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      value: 'a'
    }
  }

  render() {
    const { classes, dispatch, classifications, users,t } = this.props;

        let maxLevel = Math.max(...classifications.map(classification => classification.level));
        let heighestMessage = <span>{t('Can see')}<strong>{t('ALL')}</strong> {t('items')}</span>
        let middleLayers = <span>{t('Can see items in this layer and below')}</span> 

        let publicUsers = users.filter(user => user.classification === 0)
        let publicMessage = <span>{t('Can see ')}<strong>{t('ONLY')}</strong> {t('public items')} ({publicUsers.length} {t('users')})</span>

      var content = classifications.map((classification) => {
        let numUsers = users.filter(user => 
            user.classification === classification.level
        )

        let description = classification.level === maxLevel ? heighestMessage : middleLayers

        return <ListItem 
          button 
          onClick={() => {
            // Set mapping as currently editted
            dispatch({ type: 'MAPPING_EDIT_CLASSIFICATION', currentClassification: classification })

            // Goto editing page
            this.props.goTo({ pathname: '/admin/classifications/edit' })

          }} >
          <Avatar>{t(classification.level)}</Avatar>
          <ListItemText 
            primary={t(classification.displayName)} 
            secondary={description.props.children.concat(" (" + numUsers.length + t(" users)"))} />
        </ListItem>
      })

    return <AppContent >
        <PageContentWrapper drawer={<AdminSettingsDrawer selected={t("classifications")}/>}>
            <Grid spacing={16}>
            <AdminSettingsTitle text={t('Manage classification')} />
                    <Paper className={classes.paperStyle}>
                        <List>
                            { content }
                            <ListItem >
                                <Avatar>P</Avatar>
                                <ListItemText 
                                    primary={t("Public")}
                                    secondary={t(publicMessage)} />
                            </ListItem>
                        </List>
                        <Button
                            className={classes.button}
                            variant="raised"
                            onClick={() => {
                                // Set mapping as currently editted
                                this.props.dispatch({
                                    type: 'MAPPING_EDIT_MAPPING', currentMapping: {
                                        org: {},
                                        displayName: '',
                                        uId: '',
                                        level: 1
                                    }
                                })
                                // Goto editing page
                                this.props.goTo({ pathname: '/admin/classifications/create' })
                            }}
                        >
                            {t('New Classification')}
                        </Button>
                    </Paper>
                </Grid>
        </PageContentWrapper>
      </AppContent>;
    }
}
const mapStateToProps = (state) => ({
  ...state.services,
  templates: state.globalData.templates,
  users: state.globalData.users,
  classifications: state.globalData.classifications
})

const mapDispatchToProps = dispatch => {
  return {
    goTo: path => { dispatch(push(path)) },

    dispatch: dispatch
  }
}

export default compose(withStyles(styles),
withTranslation('admin'),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ))(Classification);